// extracted by mini-css-extract-plugin
export var additional = "subscribe-today_additional__z8B9y";
export var confirm = "subscribe-today_confirm__8Qfh+";
export var desktopLayout = "subscribe-today_desktopLayout__jXPGz";
export var desktopPlaceholder = "subscribe-today_desktopPlaceholder__LuTQ-";
export var mobileLayout = "subscribe-today_mobileLayout__g-WwG";
export var plans = "subscribe-today_plans__xhtFL";
export var purchase = "subscribe-today_purchase__JNJmA";